import { render, staticRenderFns } from "./ReportSalesPerDayPage.vue?vue&type=template&id=63500d73&scoped=true"
import script from "./ReportSalesPerDayPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesPerDayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63500d73",
  null
  
)

export default component.exports